import { MaskedLines, Reveal } from "@/lib/motion";

// Reusable inner-page hero
export const PageHero = ({ index, overline, titleLines, intro }) => {
  return (
    <section className="pt-36 md:pt-44 pb-16 md:pb-20 border-b border-line">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-9">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-oxblood flex items-center gap-3">
                {index && <span className="font-serif text-base not-italic">{index}</span>}
                {overline}
              </p>
            </Reveal>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.92] mt-6 font-medium">
              <MaskedLines lines={titleLines} delay={0.15} />
            </h1>
          </div>
          {intro && (
            <div className="lg:col-span-3">
              <Reveal delay={0.4}>
                <p className="text-ink-soft leading-relaxed border-l border-line pl-5">
                  {intro}
                </p>
              </Reveal>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

// Prose block for legal / long-form content
export const Prose = ({ children }) => (
  <div className="mx-auto max-w-[820px] px-6 md:px-12 py-16 md:py-24 space-y-10">
    {children}
  </div>
);

export const Clause = ({ number, title, children }) => (
  <Reveal>
    <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-4 md:gap-8">
      <span className="font-serif text-2xl text-oxblood leading-none">{number}</span>
      <div>
        <h3 className="font-serif text-2xl sm:text-3xl mb-3 leading-snug">{title}</h3>
        <div className="text-ink-soft leading-relaxed space-y-4">{children}</div>
      </div>
    </div>
  </Reveal>
);
